import React from 'react';

/**
 * Cloud-shaped section divider.
 * - The wrapper background = section ABOVE (topColor)
 * - The SVG fill = section BELOW (bottomColor)
 * - The path is composed of multiple soft puffs to look like a real cloud
 *   (similar to holsteiner-huepfburgenverleih.de aesthetic).
 *
 * Important: `display:block` + line-height:0 + negative margins remove
 * any sub-pixel rendering gap (the classic SVG "bar" artifact).
 */
const CloudDivider = ({ topColor = '#ffffff', bottomColor = '#f0f9ff' }) => {
  return (
    <div
      className="relative w-full overflow-hidden"
      style={{
        marginTop: '-1px',
        marginBottom: '-1px',
        lineHeight: 0,
        fontSize: 0,
      }}
      aria-hidden="true"
    >
      <svg
        className="block w-full h-10 md:h-16"
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        style={{ display: 'block' }}
        aria-hidden="true"
      >
        {/* topColor als solide Fläche im SVG selbst — vermeidet Sub-Pixel-
            Nähte zwischen CSS-Hintergrund und SVG-Fill (sonst entstehen
            an manchen DPI/Zooms feine Linien am Wellenrand). */}
        <rect x="0" y="0" width="1440" height="100" fill={topColor} />
        {/* Very gentle wave – only 3 soft bumps */}
        <path
          fill={bottomColor}
          d="M0,50
             C 240,50  320,25  480,25
             C 640,25  720,50  960,50
             C 1200,50 1280,25 1440,25
             L 1440,100 L 0,100 Z"
        />
      </svg>
    </div>
  );
};

export default CloudDivider;
